import React, { useCallback, useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-multi-lang'

// Redux
import { useDispatch, useSelector } from 'react-redux'
import { paymentVouchersSlice, paymentVouchersState } from './PaymentVouchersSlice'

import {
  edit_expenses, expense_mode, expenses, expenses_response
  , expensesType_response, iExpensesFetchData, img_url,
} from '../../services/api/api'

// Components
import TableActionBar from '../../components/TableActionBar/TableActionBar'

import { EllipsisLoader, ErrorMark, MySuccessMark, WhiteboxLoader } from '../../components/Loader/Loader'


import { Confirm } from '../../components/Alerts/Alerts'
import { havePermission } from '../../services/hoc/permissions'
import { useLocation } from 'react-router-dom'


import { useAPI } from '../../services/hoc/useAPI'
import { AxiosError } from 'axios'
import { useNotification } from '../../services/usenotification'
import ExcellikeTable from '../../components/editble-table/ExcellikeTable'
import { useFormik } from 'formik'

import { convertDate } from '../../services/convertDate'
import { dateSchema, ExpensesValidation, ExpensesValidationByRow, FileFieldValidationByRow } from './validation'
import { WarningConfirmDialog } from '../../components/WarningModal/WarningModal'
import { List } from 'react-window'
import { HeaderRow, SingleRow, singleRowProps } from '../../components/Virtulization/TableWindow'
import { IconButton } from '@mui/material'
import { AddBox, Save } from '@mui/icons-material'
import GreenButton from '../../components/buttons/green-button'

interface iFormik extends expenses_response {
  enabled?: boolean,
  expense_type?: expensesType_response,
  expense_mode_id?: number,
  invoice_copy_file?: File,
  invoice_copy_spare?: string,
  new_line?: boolean,
}


let expense_mode_options = [{ name: 'Cash', value: 1 }, { name: 'Bank Transfer', value: 2 }]


const PaymentVoucher = () => {

  // Translation
  const today = new Date().toISOString().split("T")[0];
  const t = useTranslation()
  const [pagesInfo, setPagesInfo] = useState({ page: 1, lastPage: 1 });
  const [isSucceed, setIsSucceed] = useState(false);
  const [isFailed, setIsFailed] = useState(false);
  const [date, setDate] = useState({ date_from: today, date_to: today })
  const [dateError, setError] = useState<null | ''>('')
  const [selected_rows, setSelectRow] = useState<Set<number>>(new Set())
  const { alertError500, alert } = useNotification()
  const new_line_count = useRef<number>(1)
  const [formikDirty,setFormikDirty]=useState(false)
  
  const [chosenFilter , setChosenFilter] = useState<expensesType_response|null>()
  const [openWarning, setOpenWarning] = useState<{ open: boolean, fun?: Function }>({ open: false, fun: undefined })
  const [debounce ,setDebounce] = useState<number>(0)
  const location = useLocation()
  // Redux
  const dispatch = useDispatch()
  const formik = useFormik<iFormik[]>(
    {
      initialValues: [{

      }],
      onSubmit: () => { },
   
      validateOnBlur:true,
      validateOnChange:false,
      
    }
  )
  const state = useSelector((state: { payment_vouchers: paymentVouchersState }) => state.payment_vouchers)

  const fetchExpensesType = () => {
    ENDPOINTS.expensesType()
      .index({ page: 1, page_size: 1000 })
      .then(res => {
        dispatch(paymentVouchersSlice.actions.initExpensesType(res.data.data.expensetypes))
      })
      .catch((err) => alertError500(err))
  }
  const keyword_ref = useRef(new Map())
  const ENDPOINTS = useAPI()


  const search = (value: string) => {

    dispatch(paymentVouchersSlice.actions.reset())
    Boolean(value) ?  keyword_ref.current.set('search',value):keyword_ref.current.delete('search')
    fetchData({ page: 1,date_from:date.date_from,date_to:date.date_to, keyword: value });
  }

    // const search = (value: string,filter_data?:boolean) => {
    //  if (!filter_data) dispatch(ordersSlice.actions.reset());
    //   keyword_ref.current=Boolean(value)?value:null
    //   fetchData(1,Boolean(value)? 20:8, value,filter_data);
    // };

  const addVoucher = (values: expenses[],arr_idx:number[]) => {
    let form_data = new FormData()
    values.map((ele, idx) => {
      form_data.append(`expenses[${idx}][expense_type_id]`, ele['expense_type_id'].toString())
      form_data.append(`expenses[${idx}][expense_date]`, ele['expense_date'])
      form_data.append(`expenses[${idx}][expense_value]`, ele['expense_value'].toString())
      form_data.append(`expenses[${idx}][vat]`, ele['vat'].toString())
        form_data.append(`expenses[${idx}][tax_num]`, ele['tax_num']??'')
      form_data.append(`expenses[${idx}][expense_mode]`, ele['expense_mode'])
      form_data.append(`expenses[${idx}][invoice_num]`, ele['invoice_num'])
      form_data.append(`expenses[${idx}][invoice_date]`, ele['invoice_date'])
      if (ele['invoice_copy']) form_data.append(`expenses[${idx}][invoice_copy]`, ele['invoice_copy'])
      form_data.append(`expenses[${idx}][notes]`, ele['notes'])
    })
    dispatch(paymentVouchersSlice.actions.setIsLoading(true))
    ENDPOINTS.expenses().store(form_data)
      .then(res => {
       let i = 0
        let expenses = res.data.data
        let new_values = [...formik.values]
        let new_line_values = arr_idx.map(ele=>
        {
          new_values[ele] = {...new_values[ele],...expenses[i], invoice_copy: img_url + expenses[i].invoice_copy
              , new_line: false, enabled: false}
            i += 1   
        }
        )
     



        dispatch(paymentVouchersSlice.actions.setIsLoading(false))
        setIsSucceed(true)
       
        formik.setValues(pre => new_values)
      })
      .catch((err: AxiosError) => {
        setIsFailed(true)
        alertError500(err)
        dispatch(paymentVouchersSlice.actions.setIsLoading(false))
      })

  }

  const editVoucher = (values: edit_expenses[], index?: number[]) => {
    let form_data = new FormData()
    values.map((ele, idx) => {
      form_data.append(`expenses[${idx}][expense_type_id]`, ele['expense_type_id'].toString())
      form_data.append(`expenses[${idx}][expense_date]`, ele['expense_date'])
      form_data.append(`expenses[${idx}][expense_value]`, ele['expense_value'].toString())
      form_data.append(`expenses[${idx}][vat]`, ele['vat'].toString())
      form_data.append(`expenses[${idx}][tax_num]`, ele['tax_num']??'')
      form_data.append(`expenses[${idx}][expense_mode]`, ele['expense_mode'])
      form_data.append(`expenses[${idx}][invoice_num]`, ele['invoice_num'])
      form_data.append(`expenses[${idx}][invoice_date]`, ele['invoice_date'])
      if (ele['invoice_copy']) form_data.append(`expenses[${idx}][invoice_copy]`, ele['invoice_copy'])
      form_data.append(`expenses[${idx}][notes]`, ele['notes'])
      form_data.append(`expenses[${idx}][id]`, ele['id'].toString())
    })
    dispatch(paymentVouchersSlice.actions.setIsLoading(true))
    ENDPOINTS.expenses().update(form_data)
      .then(res => {
        dispatch(paymentVouchersSlice.actions.setIsLoading(false))
        setIsSucceed(true)
        if (index) handleEditLine(index)
      })
      .catch((err: AxiosError) => {
        alertError500(err)
        setIsFailed(true)
        dispatch(paymentVouchersSlice.actions.setIsLoading(false))
      })

  }

  const addEmptyRow = () => {


    formik.setValues(pre=>([...pre,createEmptyRow()]))
  }

  const createEmptyRow = ():iFormik=>(
       {expense_date: today,
      expense_mode: 'Cash',
      expense_mode_id: -1,
      expense_type_code: '',
      expense_type_id: -1,
      expense_type_name: '',
      expense_value: '',
      invoice_copy: undefined,
      notes: '',
      invoice_num: '',
      invoice_date: today,
      vat: '',
      enabled: true,
      new_line: true}
       )
 

  // Fetch Data
  const fetchData = useCallback((
    fetch_props: iExpensesFetchData
  ) => {
    dispatch(paymentVouchersSlice.actions.setIsFetching(true))
      dispatch(paymentVouchersSlice.actions.setIsLoading(true))

    let { page, page_size = 1000, keyword, sort_direction='DESC', sort_field=74, date_from, date_to } = fetch_props
    keyword = Boolean(keyword) ? keyword : keyword_ref.current.has('search') ? keyword_ref.current.get('search'):
                                keyword_ref.current.has('filter')?keyword_ref.current.get('filter') : ''
    ENDPOINTS.expenses().index({
      page
      , page_size
      , keyword,
      sort_direction
      , sort_field
      , date_from
      , date_to

    })
      .then((response) => {
     
        if (response.data.data.last_page)
          setPagesInfo((pre) => ({
            ...pre,
            lastPage: response.data.data.last_page,
          }));
        dispatch(paymentVouchersSlice.actions.setPage(pagesInfo.page))
        // if (response.data.data.last_page)setPagesInfo(pre=>({...pre,lastPage:response.data.data.last_page}))
        let paymentVouchers: expenses_response[] = response.data.data.vouchers.map((paymentVoucher): expenses_response => paymentVoucher)
        let formik_values: iFormik[] = paymentVouchers.map(ele => {
          let expense_target = expense_mode_options.find(o => o.name == ele.expense_mode)

          return ({
            ...ele
            , expense_mode_id: expense_target ? expense_target.value : -1
            , invoice_copy: img_url + ele.invoice_copy
            , enabled: false
          })

        })
        formik_values.push(createEmptyRow())

        formik.resetForm({values:formik_values})

        //dispatch(paymentVouchersSlice.actions.init(formik_values))
        //addEmptyRow()
        //dispatch( paymentVouchersSlice.actions.setHasMore( page < Number(response.data.data.last_page) ) )

        if (!state.isLoaded)
          dispatch(paymentVouchersSlice.actions.setIsLoaded(true))
      })
      .catch((err: AxiosError) => {
        alertError500(err)
       
      })
      .finally( ()=>{
             dispatch(paymentVouchersSlice.actions.setIsLoading(false))
         
             dispatch(paymentVouchersSlice.actions.setIsFetching(false))
      }
      )
  }, [state.isLoaded, pagesInfo.page, keyword_ref.current])




  // Delete
  const remove = (ids: number[]) => {

    dispatch(paymentVouchersSlice.actions.setIsLoading(true))
    ENDPOINTS.expenses().delete({ ids })
      .then(() => {
        setSelectRow(new Set())
        dispatch(paymentVouchersSlice.actions.setIsLoading(false))
        dispatch(paymentVouchersSlice.actions.deletePaymentVouchers(ids))
        let new_details = formik.values ?
          formik.values.map(ele => ({ ...ele })).filter((ele, i) => !ids.includes(ele.id ?? -1)) : []

        formik.setValues(pre => new_details);
      })
      .catch((err: AxiosError) => {
        alertError500(err)
        dispatch(paymentVouchersSlice.actions.setIsLoading(false))

      })
  }


  // First fetch
  useEffect(() => {
    if (!state.isFetching) {
      fetchData({ page: 1 })
      fetchExpensesType()
    }
  }, [])



  useEffect(() => {
    if (location.state) {
      if (!state.isFetching) {


        search(location.state.key)
      }
    }
    else {

      if (!state.isLoaded && !state.isFetching) {

        fetchData({ page: 1 })
        fetchExpensesType()
      }
    }

  }, [])

  // useEffect(()=>{
  //     if (pagesInfo &&  pagesInfo.page!== state.page){
  //         if(!state.isFetching ) {
  //             paymentVouchersSlice.actions.setPage(pagesInfo.page)
  //             fetchData({page:pagesInfo.page,page_size:10,date_to:date.date_to,date_from:date.date_from})
  //         }
  //     }
  // },[pagesInfo])

  useEffect(() => {

      // if (!state.isFetching) {
      //   fetchData({ page: 1 })
      // }
      
      setTimeout(()=>setDebounce(pre=>pre+1),1000)

    
  }, [date])

  useEffect(()=>{
    fetchDataByDate()
  },[debounce])

  // useEffect(() => {
  //   if (state.expensesList && state.expensesList[state.page]) {
  //     let new_values = addEmptyRow(state.expensesList[state.page)
  //     formik.setValues(pre => new_values as any,false)
  //   }

  // }, [state.expensesList])


  useEffect(()=>{
      if (chosenFilter) fetchData({page:1,date_from:date.date_from,date_to:date.date_to,keyword:chosenFilter.code})

        else {
          fetchData({page:1,date_from:date.date_from,date_to:date.date_to})
        }
   
    },[chosenFilter])
  


  const customHandleChange =async (e: React.ChangeEvent, index: number) => {
    let target = (e.target as HTMLInputElement)
    let match = target.name.match(/\[(\w+)\]$/)
    let _input_name = match ? match[1] : ''
    let values = [...formik.values]
    let changed_row = {...values[index]}

    if (target.name.includes('expense_mode_id')) {
      let ex_mode = expense_mode_options.find(ele => ele.value == parseInt(target.value))
      if (ex_mode) {


       changed_row['expense_mode'] = ex_mode.name as expense_mode
       changed_row['expense_mode_id'] = ex_mode.value


      }

    }
    else if (target.name.includes('expense_type_id')) {
      let target_expense_type = state.expensesType.find(ele => ele.id == parseInt(target.value))
      if (target_expense_type) {


       changed_row['expense_type_id'] = target_expense_type.id
       changed_row['expense_type_name'] = target_expense_type.expense +'/'+target_expense_type.code
       changed_row['expense_type_code'] = target_expense_type.code


      }

    }
    else if (target.name.includes('invoice_copy')) {


     return


    }
    else {
      type k_iformik = keyof iFormik
     changed_row[_input_name as k_iformik] = target.value as any


    }

    await validateByRow(changed_row,index)
    values[index]=changed_row
    formik.setValues(pre => values)




  }

 const handleRemoveNewLine =(index:number)=> {
  const new_values= formik.values.filter((ele,i)=>index !==i)
  formik.setValues(pre=>new_values)
 }
  const handleRemoveLine = (ids:number[]) => {
  
    if (havePermission('Delete Expense List')) {
      
      if (ids.length > 0) {

        Confirm({
          message: t("delete_confirmation"),
          onConfirm: () => remove(ids as number[])
        })
      }
      if (ids.length>0){

        const immediate_delete = formik.values.filter((ele, i) => {
          const isMarked = ids.includes(i)
         
  
          // remove only: marked AND no id
          return !(isMarked )
        })
        if (immediate_delete && immediate_delete.length > 0) formik.setValues(pre => immediate_delete);
      }
    

    }
    else {
      let message = t('no_edit_permission')
      alert({ en: message, ar: message }, 'info')
    }
  };


  const handleDownload = async(ids: number[]) => {
  
    if (havePermission('Show Expense List')) {
    
      if (ids.length > 0) {

       
          try {
            const response = await ENDPOINTS.expenses().download({ids})
            const blob = new Blob([response.data], {
                type: "application/zip",
              });

              const url = window.URL.createObjectURL(blob);
              const a = document.createElement("a");

              a.href = url;
              a.download = "expenses.zip";
              document.body.appendChild(a);
              a.click();

              a.remove();
              URL.revokeObjectURL(url);
            } catch (error) {
              console.error("Download failed:", error);
            }

      }
      else {
      let message = t('no_files_to_show')
      alert({ en: message, ar: message }, 'info')
    }
    }
    else {
      let message = t('no_edit_permission')
      alert({ en: message, ar: message }, 'info')
    }
  };


  const measureSafty = (arr_index: number[]) => {
    let any_new_lines = formik.values.filter(ele => ele.new_line)
    let any_data = any_new_lines.some(ele => Boolean(ele.expense_value) ||
      Boolean(ele.invoice_copy) ||
      Boolean(ele.vat) ||
      Boolean(ele.notes))
    if (any_data) {
      setOpenWarning({ open: true, fun: () => handleEditLine(arr_index) })
    }
    else {
      handleEditLine(arr_index)
    }

  }

 const isEmptyRow = (row: iFormik): boolean => {
  const empty = createEmptyRow();
  const keys= Object.keys(empty).filter(ele=> ele !=='expense_date' && ele !== 'invoice_date' )
  return keys.every((key) => {
    
    return row[key as keyof iFormik] === empty[key as keyof iFormik];
  });
};

   const handleEditNewLine = (ids: number[]) => {

    if (ids.length) {

       let new_details=formik.values.filter((ele)=>ids.includes(ele.id??-1))
      new_details.map(ele => {
        let enabled = ele.enabled

        if (!enabled && typeof (ele.invoice_copy) == 'string')
          ele.invoice_copy_spare = ele.invoice_copy
        ele.invoice_copy = !enabled ? undefined : ele.invoice_copy_spare
        ele.enabled = !enabled

      })
      let any_enabled: boolean = new_details.some(ele => ele.enabled)
      if (!any_enabled) new_details.push(createEmptyRow())


      //dispatch(orderSlice.actions.copyGlassWorks({ arr_index }))
      formik.setValues(pre=>new_details);

    }
  };

  const handleEditLine = (arr_idx: number[]) => {
  if (!arr_idx.length) return;

  const idx = arr_idx[0];
  const current = formik.values[idx];

  if (!current) return;

  const new_val = { ...current };

  const enabled = !!new_val.enabled;

  // save old copy when disabling
  if (enabled && typeof new_val.invoice_copy === "string") {
    new_val.invoice_copy_spare = new_val.invoice_copy;
  }

  // restore when enabling
  new_val.invoice_copy = !enabled
    ? new_val.invoice_copy_spare
    : undefined;

  new_val.enabled = !enabled;

  const new_values = [...formik.values];
  new_values[idx] = new_val;

  formik.setValues(new_values);
};

  // const handleEditLine = (arr_idx: number[]) => {

  //   if (arr_idx.length>0) {

  //     let new_details = arr_idx.map(ele=> {
  //        let new_val =formik.values[ele]? {...formik.values[ele]}:{}
  //       if (new_val && new_val.enabled){
            
  //            let enabled=new_val.enabled
          
  //          if (!enabled && typeof (new_val.invoice_copy) == 'string')
  //            new_val.invoice_copy_spare = new_val.invoice_copy
  //          new_val.invoice_copy = !enabled ? undefined : new_val.invoice_copy_spare
  //          new_val.enabled = !enabled
  //       }
  //       return new_val
  //     })[0]
  //     let new_values = [...formik.values]
  //     new_values[arr_idx[0]]=new_details
  //     formik.setValues(pre=>new_values);

  //   }
  // };

  const handleSaveLine = (arr_idx: number[]) => {

    if (formik.values
      && formik.values?.length >= arr_idx.length) {
      // let edited_line = formik.values.filter((ele, index) => {
      //   let is_marked = arr_ids.includes(ele.id??0)
      //   let enabled = ele.enabled
      //   return (is_marked && enabled)
      // })
      let edited_line = arr_idx.map(ele=> formik.values[ele].enabled? ({...formik.values[ele]}): {})

      processValues(edited_line, { editFun: editVoucher, index: arr_idx })


    }
  };


  const processValues = (values: iFormik[],
    handlers: {
      addFun?: (v: expenses[],arr_idx:number[]) => void
      , editFun?: (v: edit_expenses[], arr_index?: number[]) => void, index?: number[]
    }) => {
    if (handlers.addFun) {
      let new_lines= []
      let new_lines_index = []
      let last_index= values.length -1
      let i=last_index
      while (i >= 0 && new_lines.length < new_line_count.current){
        if (values[i].new_line && !isEmptyRow(values[i]) ) {
          new_lines.push({...values[i]})
          new_lines_index.push(i)
        }
          i--
      }
      if (new_lines.length >0){
        let processed_values = new_lines
          .map(ele => ({
            expense_date: convertDate(ele.expense_date ?? ''),
            expense_mode: ele.expense_mode ?? 'Cash',
            expense_type_id: ele.expense_type_id ?? -1,
            expense_value: parseFloat(ele.expense_value ?? '0') ?? 0,
            invoice_copy: ele.invoice_copy_file ?? null,
            invoice_date: convertDate(ele.invoice_date ?? ''),
            invoice_num: ele.invoice_num ?? '',
            notes: ele.notes ?? '',
            vat: parseFloat(Boolean(ele.vat)&&ele.vat?ele.vat :'0') ?? 0,
            tax_num: ele.tax_num


          }))
        handlers.addFun(processed_values,new_lines_index)
      }
    }
    else if (handlers.editFun) {
      let processed_values = values.filter(ele => !ele.new_line && ele.enabled)
        .map(ele => ({
          expense_date: convertDate(ele.expense_date ?? ''),
          expense_mode: ele.expense_mode ?? 'Cash',
          expense_type_id: ele.expense_type_id ?? -1,
          expense_value: parseFloat(ele.expense_value ?? '0') ?? 0,
          invoice_copy: ele.invoice_copy_file ? ele.invoice_copy_file : null,
          invoice_date: convertDate(ele.invoice_date ?? ''),
          invoice_num: ele.invoice_num ?? '',
          notes: ele.notes ?? '',
          vat: parseFloat(ele.vat ?? '0') ?? 0,
          id: ele.id ?? -1,
          tax_num: ele.tax_num

        }))
      handlers.editFun(processed_values, handlers.index)

    }


  }


  const determinFunction = (values: iFormik[]) => {

    return processValues(values, { addFun: addVoucher   }) 
  }
 
  const router = (router: string) => {
    if (havePermission('Show Report')){
       let keyword = keyword_ref.current.has('search') ? keyword_ref.current.get('search'):
                                keyword_ref.current.has('filter')?keyword_ref.current.get('filter') : '' 
    window.open(
      `spreedsheet` +
        `/${router}/${date.date_from}/${date.date_to}/${keyword}` 
    );
    }
    else {
      let message=t('no_show_permission')
      alert({en:message,ar:message},'info')
    }
  };

    const handleChosenFilter =(item:expensesType_response|null)=>{
      //dispatch(ordersSlice.actions.filterOrders({option:item}))
      
      setChosenFilter(pre=>item)
      if (item) {
        // search((item?.code??'').toString())
        keyword_ref.current.set('filter',item.code??'')
        fetchData({page:1,date_from:date.date_from,date_to:date.date_to,keyword:item.code})
      }   
      else {
         keyword_ref.current.delete('filter')
        fetchData({page:1,date_from:date.date_from,date_to:date.date_to})
      }
     
    }

const fetchDataByDate = ()=>{

if (date.date_from && date.date_to) {

      dateSchema
        .validate(date)
        .then(() => {
          if (dateError) setError(pre => null)
          if (!state.isFetching) {
            fetchData({ page: 1, date_to: date.date_to, date_from: date.date_from })
          }

        }
        )
        .catch(err => {
          setError(pre => err.errors[0])

        }
        )


    }
  }

const validateByRow = async (values:iFormik, index:number) => {
  try {
    await ExpensesValidationByRow.validate(values, { abortEarly: false });

    // clear ALL row errors
    
    const newErrors= { ...formik.errors };
    delete newErrors[index];

    formik.setErrors(newErrors);
  } catch (err:any) {
     const rowErrors: { [k: string]: string } = {};


    if (err.inner) {
      err.inner.forEach((e:any) => {
        rowErrors[e.path] = e.message;
      });
    }

     const newErrors = { ...formik.errors };
    newErrors[index] = rowErrors;

    formik.setErrors(newErrors);
  }
};

const validateFileByRow= async (values:iFormik, index:number) => {
  try {
    await FileFieldValidationByRow.validate(values, { abortEarly: false });

    // clear ALL row errors
    
    const newErrors= { ...formik.errors };
    delete newErrors[index];

    formik.setErrors(newErrors);
  } catch (err:any) {
     const rowErrors: { [k: string]: string } = {};


    if (err.inner) {
      err.inner.forEach((e:any) => {
        rowErrors[e.path] = e.message;
      });
    }

     const newErrors = { ...formik.errors };
    newErrors[index] = rowErrors;

    formik.setErrors(newErrors);
  }
};


  return (
    <>
      {state.isLoaded ?
        <>
          <MySuccessMark succeed={isSucceed} setSucceed={setIsSucceed} />
          <ErrorMark failed={isFailed} setFailed={setIsFailed} />
          {state.isLoading ? <WhiteboxLoader /> : ""}
          <TableActionBar
            keyword={location.state ? location.state.key : ''}
            showFilter={false}
            title={t("payment_vouchers")}
            search={search}
           
            showDelete={selected_rows.size > 0}
            delete={
              () => {
                handleRemoveLine(Array.from(selected_rows))
              }

            }

              addText={t('export_xsl')}
              add={()=>router('getExpenses')
            }
            date_from={date.date_from}
            date_to={date.date_to}
            dateFromError={dateError}
            dateToError={dateError}
            setDateFrom={(v: React.ChangeEvent<HTMLInputElement>) =>
              setDate(pre => ({ ...pre, date_from: v.target.value }))}
            setDateTo={(v: React.ChangeEvent<HTMLInputElement>) =>
              setDate(pre => ({ ...pre, date_to: v.target.value }))}
           
            clearDate={
              date.date_from || date.date_to ?
                () => {
                  setDate(pre => ({ date_from: '', date_to: '' }))
                  setError(pre => null)
                } : undefined
            }
             handleFilter={(item:any)=>{

       
              handleChosenFilter(item)
             }
             }
             filterValue={chosenFilter}
          />

      
          {/* <ExcellikeTable
              
              handleDownload={handleDownload}
            setFieldValue={formik.setFieldValue}
            noPagination={true}
            handleChange={customHandleChange}
            handleBlur={formik.handleBlur}
            error={formik.errors}
            has_general_options={false}
            lines_number={formik.values ? Object.keys(formik.values).length : 0}
            values={(() => {
              let obj: { [key: number]: iFormik } = {};
              let index = 0
              // eslint-disable-next-line @typescript-eslint/no-unused-expressions
           if  (state.expensesList && state.expensesList.length > 0){
                 state.expensesList.map(
                  (ele) =>{
                    index ++
                  (obj[index] = {
                    ...ele,
                    expense_value: ele.expense_value,
                    vat: ele.vat,
                    tax_num: ele.tax_num,
                    expense_mode: ele.expense_mode,
                    invoice_num: ele.invoice_num,
                    expense_date: ele.expense_date,
                    expense_type_id: ele.expense_type_id,
                    invoice_copy: ele.invoice_copy,
                    invoice_date: ele.invoice_date,
                    notes: ele.notes,
                    expense_mode_id: ele.expense_mode_id

                  })
                }
                )
              
                }
                
               if (formik.values && formik.values.length>0 ){
                 formik.values.forEach(ele=>{
                  index ++ 
                   (obj[index] = {
                    ...ele,
                    expense_value: ele.expense_value,
                    vat: ele.vat,
                    tax_num: ele.tax_num,
                    expense_mode: ele.expense_mode,
                    invoice_num: ele.invoice_num,
                    expense_date: ele.expense_date,
                    expense_type_id: ele.expense_type_id,
                    invoice_copy: ele.invoice_copy,
                    invoice_date: ele.invoice_date,
                    notes: ele.notes,
                    expense_mode_id: ele.expense_mode_id

                  })

                })}
              return obj;
            })()}
            touched={formik.touched}
            headers_key={[
              'expense_date',
              'expense_type_id',
              'expense_value',
              'vat',
              'tax_num',
              'expense_mode_id',
              'invoice_num',
              'invoice_date',

              'invoice_copy',

              'notes',

            ]}

            headers={[
              t('expense_date'),
              t('expense_type'),
              t('expense_value'),
              t('VAT'),
              t('tax_num'),
              t('expense_mode'),
              t('invoice_num'),

              t('invoice_date'),
              t('invoice_copy'),

              t('notes'),

            ]}
            selectInput={['expense_type_id', 'expense_mode_id']}
            options={{
              'expense_type_id': state.expensesType.map(ele => ({ ...ele, value: ele.id, name: ele.expense+'/'+ele.code }))
              , 'expense_mode_id': expense_mode_options
            }}

            types_input={{
               'invoice_copy': 'file'
              , 'expense_date': 'date'
              , 'invoice_date': 'date' 
              , "notes":'note'}}
            removeLine={handleRemoveLine}
            setFieldTouched={formik.setFieldTouched}

            EditLine={measureSafty}
            addLine={() => {
              // let new_lines = formik.values.filter(ele => ele.new_line)
              // if (new_lines.length > 4) return undefined
              if (new_line_count.current >4) return undefined
              new_line_count.current+=1
     
              let new_values = addEmptyRow(formik.values)
              formik.setValues(new_values as any,false)
            }}

            save={
            
                () => determinFunction(formik.values) 
            }

            selected_rows={selected_rows}
            setSelectRow={setSelectRow}
            saveLine={handleSaveLine}
            double_name_error={{ 'invoice_copy': 'invoice_copy_file' }}
            is_valid={formik.isValid}
            save_valid={ formik.dirty &&
                formik.isValid &&
                formik.values.filter(ele => ele.new_line).length > 0 }
            spans={spans}
          

          /> */}
          <div
  style={{
    width: "100%",
    border: "1px solid #e5e7eb",
    borderRadius: "6px",
    overflow: "hidden"
  }}
>
  <HeaderRow 
   selected={selected_rows}
   setSelected={setSelectRow}
   handleDownload={()=>handleDownload(Array.from(selected_rows))}
   removeSelected={()=> {
    if (new_line_count.current <5){

      new_line_count.current +=1
      handleRemoveLine(Array.from(selected_rows))
    }
   } }

  />
  <div className="tableWrapper">
     
        <List<singleRowProps>
           
           style={{
            height:'500px',
            minWidth:'500px',
     
            
           }}
            rowCount={formik.values.length}
            rowHeight={50}
            rowComponent={SingleRow}
            rowProps={{
              rows: formik.values,
              handleChange:(e,i)=>{ 
          
                customHandleChange(e,i)},
              options: {
                expense_type_id: state.expensesType.map(ele => ({
                  ...ele,
                  value: ele.id,
                  name: ele.expense + '/' + ele.code
                })),
                expense_mode_id: expense_mode_options,

              },
              selected:selected_rows,
              setSelected:setSelectRow,
              editLine:(i:number)=>handleEditLine([i]),
              isValid:formik.isValid,
              removeLine:(i)=>
                {
                  
                  handleRemoveLine([i])
                },
              handleDownload:(i:number)=>handleDownload([i]), 
              saveLine:(i:number)=>handleSaveLine([i]),
              removeNewLine:(i)=>{
                if (new_line_count.current >0)new_line_count.current -=1
                handleRemoveNewLine(i)
              },
             setFeildValue: (n: string, v: any) => {
                            

                              formik.setFieldValue(n, v);

                              // ✅ uses correct value
                            },
              errors:formik.errors,
              setFieldError:formik.setFieldError,
              deleteFieldError: (n: string,v:any) => {
                  const rowIndex = Number(n.match(/\d+/)?.[0]);

                              // build next row BEFORE updating formik
                              const nextRow = {
                                ...formik.values[rowIndex],
                                invoice_copy_file: v,
                              };
          
                     validateFileByRow(nextRow, rowIndex);
               
                
                }




              
              
            }}
          />
          
          </div>
          <div style={{
            paddingBottom:'1.1rem'
          }}>

       <IconButton sx={{color:'var(--primary-color)'}}
       className="addIcon" onClick={() => {
        if (new_line_count.current <5){
          new_line_count.current +=1
          formik.setValues(pre=>([...pre,createEmptyRow()]))
        }
       }}>
              <AddBox />
            </IconButton>
      
                 
                  <GreenButton label={t('save')} fun={() => determinFunction(formik.values) }
                    style={{ margin: '0 auto' }} disabled={formik.dirty?formik.isValid?false:true:true }
                  >
    
                    <Save className='saveIcon' />
    
                  </GreenButton>
          </div>
                
              
    </div>    
       





        </> : <div className="center"><EllipsisLoader /></div>}
      <WarningConfirmDialog
        open={openWarning.open}
        handleClose={() => setOpenWarning(pre => ({ ...pre, open: false }))}
        onConfirm={openWarning.fun ? openWarning.fun : () => { }}


      />
    </>
  )

}
export default PaymentVoucher;